import React, { Component } from 'react'

import PaginationDot from './PaginationDot'

const styles: { [Key: string]: React.CSSProperties } = {
  root: {
    display: 'flex',
    flexDirection: 'row',
  },
}

interface Props {
  onChangeIndex(index: number): void
  index: number
  dots: number
}

class Pagination extends Component<Props> {
  handleClick = (_event: React.MouseEvent, index: number) => {
    this.props.onChangeIndex(index)
  }

  override render() {
    const { index, dots } = this.props

    const children = []

    for (let i = 0; i < dots; i += 1) {
      children.push(
        <PaginationDot
          key={i}
          index={i}
          active={i === index}
          onClick={this.handleClick}
        />,
      )
    }

    return <div style={styles.root}>{children}</div>
  }
}

export default Pagination
